document.addEventListener('DOMContentLoaded', () => {
  const tabGroups = document.querySelectorAll('.js-filter-container');

  tabGroups.forEach((tabGroup, groupIndex) => {
    const section = tabGroup.closest('section');
    if (!section) return;

    // More robust panel wrapper lookup (either class-based or sibling-based fallback)
    const panelWrapper =
      section.querySelector('.js-tab-panels') ||
      tabGroup.parentElement?.nextElementSibling;
    if (!panelWrapper) return;

    const buttons = Array.from(tabGroup.querySelectorAll('.filter-button'));
    const panels = Array.from(panelWrapper.children).filter(
      (node) => node.nodeType === 1,
    );
    const activeClassAttr =
      section.dataset.activeClass || tabGroup.dataset.activeClass || 'text-cake-blue';
    const activeBtnClasses = activeClassAttr.split(' ').filter(Boolean);

    if (!buttons.length || !panels.length) return;

    const showPanel = (activeIndex) => {
      buttons.forEach((button, index) => {
        const isActive = index === activeIndex;
        button.classList.toggle('active-tab', isActive);

        activeBtnClasses.forEach((className) => {
          button.classList.toggle(className, isActive);
        });

        button.setAttribute('aria-selected', String(isActive));
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.classList.toggle('hidden', !isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    };

    buttons.forEach((button, index) => {
      const buttonId = `tab-trigger-${groupIndex}-${index}`;
      const panelId = `tab-panel-${groupIndex}-${index}`;

      button.setAttribute('id', buttonId);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', panelId);

      button.addEventListener('click', () => {
        if (index < panels.length) {
          showPanel(index);
        }
      });

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + buttons.length) % buttons.length;

        buttons[nextIndex].focus();
      });
    });

    panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('id', `tab-panel-${groupIndex}-${index}`);
      panel.setAttribute('aria-labelledby', `tab-trigger-${groupIndex}-${index}`);
    });

    tabGroup.setAttribute('role', 'tablist');

    const initialActiveIndex = buttons.findIndex((button) =>
      button.classList.contains('active-tab'),
    );
    showPanel(initialActiveIndex >= 0 ? initialActiveIndex : 0);
  });
});
